module.exports = __webpack_public_path__ + "img/home_list_icon2.1a38b259.png";